import { motion } from 'framer-motion';
import SlateLogo from './SlateLogo';

export default function LoadingScreen({ message = 'Setting up your workspace...' }) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center" data-testid="loading-screen">
      {/* Animated logo */}
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="relative mb-8"
      >
        {/* Outer pulse rings */}
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{ width: 80, height: 80, left: -16, top: -16 }}
          animate={{
            boxShadow: [
              '0 0 0 0 rgba(245, 158, 11, 0.3)',
              '0 0 0 20px rgba(245, 158, 11, 0)',
            ],
          }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeOut' }}
        />
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{ width: 80, height: 80, left: -16, top: -16 }}
          animate={{
            boxShadow: [
              '0 0 0 0 rgba(245, 158, 11, 0.2)',
              '0 0 0 35px rgba(245, 158, 11, 0)',
            ],
          }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeOut', delay: 0.4 }}
        />

        {/* Logo with breathing */}
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
        >
          <SlateLogo size={36} />
        </motion.div>
      </motion.div>

      {/* Brand name */}
      <motion.h1
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="font-heading text-xl font-semibold tracking-tight text-foreground mb-3"
      >
        Slate
      </motion.h1>

      {/* Loading bar */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="w-48 h-[2px] bg-border rounded-full overflow-hidden mb-4"
      >
        <motion.div
          className="h-full rounded-full"
          style={{ background: 'linear-gradient(90deg, #F59E0B, #D97706, #F59E0B)' }}
          animate={{ x: ['-100%', '100%'] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>

      {/* Message */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7 }}
        className="text-xs text-muted-foreground"
      >
        {message}
      </motion.p>
    </div>
  );
}
